import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { AuthHeading } from './AuthShell.jsx';
import { OtpCodeCard, useOtp } from '../components/Otp.jsx';
import { Avatar, useToast } from '../components/ui.jsx';
import { isEmail, maskEmail } from '../lib/otp.js';

/** "Forgot which address you use" — recovery email + code → masked account list. */
export function FindAddress({ api, go }) {
  const flash = useToast();
  const [step, setStep] = useState('email'); // email | otp | done
  const [rec, setRec] = useState('');
  const [results, setResults] = useState([]);
  const otp = useOtp(api, 'find');

  const send = async (e) => { e.preventDefault(); if (!isEmail(rec)) { flash('Enter a valid recovery email'); return; } if (await otp.send(rec)) setStep('otp'); };
  const verify = async () => { const token = await otp.verify(); if (!token) return; const r = await api.findAccounts(otp.token || token); setResults(r.accounts || []); setStep('done'); };

  const sub = { email: 'Enter the recovery email you added to your account. We will send a code there.', otp: `Enter the 6-digit code sent to ${maskEmail(rec)}.`, done: 'Accounts linked to this recovery email.' }[step];
  return (
    <div className="km-auth-form" style={{ width: 440 }}>
      <a href="#login" onClick={(e) => { e.preventDefault(); go('login'); }} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, alignSelf: 'flex-start' }}><ArrowLeft size={14} />Back to sign in</a>
      <AuthHeading title="Find your address" sub={sub} />
      {step === 'email' && (
        <form onSubmit={send} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <label className="km-field">Recovery email<input className="km-input" type="email" placeholder="you@personal-mail.com" value={rec} onChange={(e) => setRec(e.target.value)} /></label>
          <button type="submit" className="km-btn km-btn-lg">Send code</button>
        </form>
      )}
      {step === 'otp' && <OtpCodeCard otp={otp} onVerify={verify} />}
      {step === 'done' && (
        <div className="km-card" style={{ overflow: 'hidden' }}>
          {!results.length && <div className="km-muted" style={{ padding: 24, textAlign: 'center', fontSize: 13.5 }}>No account uses this recovery email.</div>}
          {results.map((em) => (
            <button key={em} type="button" className="km-result" onClick={() => { go('login', { email: em }); flash('Address filled in. Sign in to continue.'); }}>
              <Avatar name={em} /><span><b>{em.replace(/^(..)[^@]*/, '$1•••')}</b><small>PQC identity active</small></span><span style={{ color: 'var(--km-accent)', fontWeight: 500, fontSize: 13 }}>Sign in</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
